
import { MdOutlineLanguage } from 'react-icons/md'
import { BiCategoryAlt } from 'react-icons/bi'
import { CgCalendarDates } from 'react-icons/cg'
import { TbWorldPin } from "react-icons/tb";
import { AiFillCodeSandboxCircle } from "react-icons/ai";
import { AiOutlineCodeSandbox } from "react-icons/ai";

import GetPoster from '../types/GetPoster'

import moment from 'moment';
import 'moment/locale/fa'  // without this line it didn't work
import { AiOutlineFieldTime, AiOutlineFileDone, AiOutlineFileExclamation, AiOutlineFolder, AiOutlineUser } from 'react-icons/ai';
import { useState } from 'react';
import { useEffect } from 'react';
import { get_media } from '../../api/api';

import PhotoAlbum from 'react-photo-album';
import Lightbox from 'yet-another-react-lightbox';
import "yet-another-react-lightbox/styles.css";
import useAuth from '../../hooks/useAuth';
import { FiDownload, FiEdit3 } from 'react-icons/fi';
import { IoMdArrowBack } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import FixPanel from '../FixPanel';
import SystemRequirementDisplay from './SystemRequirementDisplay';
import useOperatingSystems from '../../hooks/useOperatingSystems';

const parse = require('html-react-parser')

const getMetadataTitle = (metadata, typeId) => {
     const titles = metadata
          ?.filter((item) => (item.type?.id ?? item.type) === typeId)
          .map((item) => item.title)
          .filter(Boolean)

     return titles?.length ? titles.join(', ') : null
}


const ItemsTypeSingle = ({ data, detailLinks = null }) => {

     const { auth } = useAuth()
     const navigate = useNavigate()

     const [images, setImages] = useState([])
     const [index, setIndex] = useState(-1);

     const [panelDownload, setPanelDownload] = useState(false)
     const [dataDownload, setDataDownload] = useState([])
     const [titleDownload, setTitleDownload] = useState('')
     const [postID, setPostID] = useState('')
     const [subjectTypeDownload, setSubjectTypeDownload] = useState(null)
     const [videosDownload, setVideosDownload] = useState([])
     const [videoDownload, setVideoDownload] = useState(null)

     const country = getMetadataTitle(data?.metadata, 3)
     const developer = getMetadataTitle(data?.metadata, 0)
     const publisher = getMetadataTitle(data?.metadata, 1)
     const osOptions = useOperatingSystems()

     useEffect(() => {
          var imgs = []

          data.galleryIds?.map(img => {
               imgs.push({ src: get_media(img), width: 100, height: 100, })
          })
          setImages(imgs)
     }, [data])


     const handleLinkDownloads = (data) => {
          setTitleDownload(data.title)
          setDataDownload(data.subjectBranch)
          setPanelDownload(true)
          setPostID(data.id)
          setSubjectTypeDownload(data.type)
          setVideosDownload(data.videos || [])
          setVideoDownload(data.video || null)
     }

     return (
          <>
               <FixPanel
                    title={titleDownload}
                    data={dataDownload}
                    post_id={postID}
                    show={panelDownload}
                    onClose={() => setPanelDownload(false)}
                    subjectType={subjectTypeDownload}
                    videos={videosDownload}
                    video={videoDownload}
               />

               {data && (
                    <div
                         className='itemBox single'
                         style={{ display: 'block', marginBottom: 0 }}
                    >
                         <div className='dtr'>

                              <div className='flex singlePost'>
                                   <div className="flex" style={{ alignItems: 'self-start' }}>
                                        <GetPoster id={data.posterId} />
                                        <div className='contentItem' style={{ height: 'auto' }}>
                                             <p className='title'>
                                                  <span className='ltr ellipsis'>{data.title}</span>{' '}
                                                  {data.persianTitle ? (<><small className='ellipsis'>({data.persianTitle})</small> </>) : ''}
                                             </p>

                                             {data.persianTitle ? (
                                                  <p className='visible-xs'>
                                                       <MdOutlineLanguage />
                                                       <span>
                                                            نام فارسی : <b>{data.persianTitle}</b>
                                                       </span>
                                                  </p>
                                             ) : (
                                                  ''
                                             )}

                                             <div style={{ marginBottom: '8px' }} className='cats'><BiCategoryAlt />
                                                  {data.categories && (
                                                       <ul>
                                                            {data.categories.map(i => (
                                                                 <li key={i.id}>{i.title}</li>
                                                            ))}
                                                       </ul>
                                                  )}

                                                  {data.ages && <>
                                                       <span style={{ marginRight: 10 }} className='ages'>{data.ages}</span>
                                                  </>}

                                             </div>

                                             {data.publishDate &&
                                                  <div className='cats' style={{ marginBottom: '8px' }}>
                                                       <AiOutlineFieldTime />
                                                       <span>انتشار : <b>{moment(data.publishDate).locale('fa').fromNow()}</b></span>
                                                  </div>
                                             }

                                             {data.size > 0 &&
                                                  <div className='cats' style={{ marginBottom: '8px' }}>
                                                       <AiOutlineFolder />
                                                       <span>حجم : <b>{data.size} گیگابایت</b></span>
                                                  </div>
                                             }

                                             {data.productionYear && (
                                                  <div className='cats' style={{ marginBottom: '8px' }}>
                                                       <CgCalendarDates />
                                                       <span>محصول : <b>{data.productionYear}</b></span>
                                                  </div>
                                             )}

                                             {country && (
                                                  <div className='cats' style={{ marginBottom: '8px' }}>
                                                       <TbWorldPin />
                                                       <span>کشور : <b>{country}</b></span>
                                                  </div>
                                             )}

                                             {data.version &&
                                                  <div className='cats' style={{ marginBottom: '8px' }}>
                                                       <AiOutlineFileExclamation />
                                                       <span>نسخه : <b>{data.version}</b>{' '}
                                                            {data.branchGroup?.length > 0 && `(${data.branchGroup.map(item => item.title)})`}
                                                       </span>
                                                  </div>
                                             }

                                             {data.producerName &&
                                                  <div className='cats' style={{ marginBottom: '8px' }}>
                                                       <AiOutlineUser />
                                                       <span>تولید کننده : <b>{data.producerName}</b></span>
                                                  </div>
                                             }

                                             {developer && (
                                                  <div className='cats' style={{ marginBottom: '8px' }}>
                                                       <AiFillCodeSandboxCircle />
                                                       <span>کمپانی سازنده : <b>{developer}</b></span>
                                                  </div>
                                             )}

                                             {publisher && (
                                                  <div className='cats' style={{ marginBottom: '8px' }}>
                                                       <AiOutlineCodeSandbox />
                                                       <span>کمپانی ناشر : <b>{publisher}</b></span>
                                                  </div>
                                             )}



                                             {data.featureItems?.length > 0 && <><div>
                                                  {data.featureItems.map(i => { return <span className='featureItemType' style={{ backgroundColor: 'var(--theme-color-1)', borderRadius: '5px', padding: '1px 6px', color: '#fff', marginLeft: '10px' }} key={i.id}>{i.title} </span> })}</div></>}


                                        </div>
                                   </div>



                                   <div className='dtl'>
                                        {auth?.role[0] === 'ADMIN' ? <button onClick={() => navigate(`/type/edit/${data.id}`)}><span className='descBTN'>ویرایش</span><span className='mobBTN'><FiEdit3 /></span></button> : ''}

                                        {data.subjectBranch.length > 0 && (<button onClick={() => handleLinkDownloads(data)}><span className='descBTN'>لینک دانلود</span><span className='mobBTN'><FiDownload /></span></button>)}

                                        <button className='bordered' onClick={() => { navigate(-1) }}><span className='descBTN'>بازگشت</span><span className='mobBTN'><IoMdArrowBack /></span></button>
                                   </div>


                              </div>

                              <br />
                              {data.description ? (
                                   <div className='htmlContent'>
                                        {parse(data.description)}
                                   </div>
                              ) : ''}

                              {data.updateInfo ? (
                                   <>
                                        <br />
                                        <div className='htmlContent'>
                                             <h2 className='titleContent'>بروزرسانی</h2>
                                             {parse(data.updateInfo)}
                                        </div>
                                   </>
                              ) : ''}

                              {data.installationGuide ? (
                                   <>
                                        <br />
                                        <div className='htmlContent'>
                                             <h2 className='titleContent'>راهنمای نصب</h2>
                                             {parse(data.installationGuide)}
                                        </div>
                                   </>
                              ) : ''}

                              <SystemRequirementDisplay
                                   minimumSystemRequirement={data.minimumSystemRequirement}
                                   recommendedSystemRequirement={data.recommendedSystemRequirement}
                                   osOptions={osOptions}
                              />

                              <div className="galleryImages">
                                   <PhotoAlbum
                                        layout="rows"
                                        photos={images}
                                        targetRowHeight={150}
                                        onClick={({ index: current }) => setIndex(current)}
                                   />

                                   <Lightbox
                                        index={index}
                                        slides={images}
                                        open={index >= 0}
                                        close={() => setIndex(-1)}
                                   />
                              </div>



                         </div>


                         {detailLinks && <div className="shop mb-0">
                              {detailLinks?.map(item => (
                                   <div key={item.id} className='box'>
                                        <h5>{item.paymentTitle} <small style={{ fontSize: 13 }}>(نسخه: {item.title})</small></h5>
                                        {parse(item.paymentDescription)}
                                   </div>
                              ))}

                              <div className="box">
                                   <h5>پشتیبانی</h5>
                                   <p>در صورت نیاز از طریق یکی از روش های زیر با پشتیبانی تماس بگیرید</p>
                                   <p>1. ارسال ایمیل به آدرس sekaanscom@gmail.com</p>
                                   <p>2. ارسال پیام به آدرس تلگرام STM_WEB</p>
                                   <p>ارسال پیام به واتس آپ یا تلگرام به شماره زیر :</p>
                                   <p>09939207262</p>
                              </div>
                              <div className="box">
                                   <h5>راهنمای دانلود</h5>
                                   <p>در گوشی های اندروید از برنامه adm جهت دانلود استفاده نمایید (پلی استور).</p>
                                   <p>در سیستم عامل IOS از برنامه Documents جهت دانلود استفاده نمایید (اپ استور).</p>
                                   <p>در کامپیوتر از نرم افزار Flash Get یا idm جهت دانلود استفاده نمایید.</p>
                              </div>

                         </div>}


                    </div>
               )}
          </>
     )
}

export default ItemsTypeSingle
